module.exports = __webpack_public_path__ + "static/img/d.a8d61de.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/d.png
// module id = SPLh
// module chunks = 1